import clipboard from 'vue-clipboard2'
import Vue from 'vue'

Vue.use(clipboard)
